/**
=========================================================
* E4A-IoT-Manager React Frontend Dashboard 
* Copyright © 2024 Electronics4All Inc.
=========================================================
*/

import { useState } from "react";

// @mui material components
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";

// Material Dashboard React components
import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import MDTypography from "components/MDTypography";

// E4A React components
import DashboardLayout from "e4acomponents/LayoutContainers/DashboardLayout";
import DashboardNavbar from "e4acomponents/Navbars/DashboardNavbar";
import Footer from "e4acomponents/Footer";
import FormField from "layouts/applications/wizard/components/FormField";
import { useNavigate } from "react-router-dom";
import PermissionManagement from "../components/permission-management";

import CrudService from "services/cruds-service";

const NewRole = () => {
  const navigate = useNavigate();
  const [permissionList, setPermissionList] = useState([]);
  const [name, setName] = useState({
    text: "",
    error: false,
    textError: "",
  });

  const changeNameHandler = (e) => {
    setName({ ...name, text: e.target.value });
  };

  const submitHandler = async (e) => {
    e.preventDefault();

    if (name.text.trim().length < 1) {
      setName({ ...name, error: true, textError: "The role name is required" });
      return;
    }

    const role = {
      data: {
        type: "roles",
        attributes: {
          name: name.text,
          permissions: permissionList,
        },
      },
    };

    try {
      await CrudService.createRole(role);
      navigate("/examples-api/role-management", {
        state: { value: true, text: "The role was sucesfully created" },
      });
    } catch (err) {
      if (err.hasOwnProperty("errors")) {
        setName({ ...name, error: true, textError: err.errors[0].detail });
      }
      console.error(err);
    }
  };

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox mt={5} mb={9}>

        <Grid container justifyContent="center">
          <Grid item xs={12} lg={8}>

            {/* Page Header */}
            <MDBox mt={6} mb={8} textAlign="center">

              <MDBox mb={1}>
                <MDTypography variant="h3" fontWeight="bold">
                  Add New Role
                </MDTypography>
              </MDBox>

              <MDTypography variant="h5" fontWeight="regular" color="secondary">
                This information will describe more about the role.
              </MDTypography>

            </MDBox>

            {/* Form */}
            <Card>
              <MDBox component="form" method="POST" onSubmit={submitHandler}>
                <MDBox display="flex" flexDirection="column" px={3} my={4}>
                  
                  <MDBox>
                    <MDTypography variant="h5" fontWeight="medium" textTransform="capitalize">
                      Role's Information
                    </MDTypography>
                  </MDBox>
                  
                  {/*Role Name Field */}
                  <MDBox p={1}>
                    <FormField
                      type="text"
                      label="Name"
                      name="name"
                      value={name.text}
                      onChange={changeNameHandler}
                      error={name.error}
                    />
                    {name.error && (
                      <MDTypography variant="caption" color="error" fontWeight="light">
                        {name.textError}
                      </MDTypography>
                    )}
                  </MDBox>

                  {/* Permission Management Section */}
                  <MDBox mt={4} mb={2}>
                    <MDBox>
                      <MDTypography variant="h5" fontWeight="medium" textTransform="capitalize">
                        Role's Permissions
                      </MDTypography>
                    </MDBox>

                    <PermissionManagement
                      initialPermissions={[...permissionList]}
                      setPermissionList={setPermissionList}
                    />

                  </MDBox>

                  {/* Cancel and Save Buttons */}
                  <MDBox ml="auto" mt={2} mb={2} display="flex" justifyContent="flex-end">
                    <MDBox mx={2}>
                      <MDButton
                        variant="gradient"
                        color="dark"
                        size="small"
                        px={2}
                        mx={2}
                        onClick={() =>
                          navigate("/examples-api/role-management", {
                            state: { value: false, text: "" },
                          })
                        }
                      >
                        Back
                      </MDButton>
                    </MDBox>
                    <MDButton variant="gradient" color="dark" size="small" type="submit">
                      Save
                    </MDButton>

                  </MDBox>
                </MDBox>
              </MDBox>
            </Card>
          </Grid>
        </Grid>
      </MDBox>
      <Footer />
    </DashboardLayout>
  );
};

export default NewRole;
